module.exports = __webpack_public_path__ + "static/img/app6.b4ed097.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/app6.jpg
// module id = qdDK
// module chunks = 0